/* eslint-disable */
import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import PageNotFound from 'partial/containers/PageNotFound';
import ResetPassword from 'modules/auth/containers/ResetPassword';
import LoginPage from 'modules/auth/containers/LoginPage';
import EditorPage from 'modules/auth/containers/EditorPage';

function Public() {
  return (
    <Switch>
      <Route exact path="/" component={LoginPage} />
      {/* <Route exact path="/editor" component={EditorPage} /> */}
      <Route exact path="/login" component={LoginPage} />
      <Route exact path="/reset-password" component={ResetPassword} />
      <Route path="/logout">
        <Redirect to="/" />
      </Route>
      <Route component={PageNotFound} />
    </Switch>
  );
}

Public.propTypes = {};

export default Public;
